import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-d-flex p-justify-center w-100" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "header-terms" }, "Terms and conditions")
], -1)
const _hoisted_2 = { class: "main-block-terms" }
const _hoisted_3 = { class: "p-d-flex p-justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_brand_terms = _resolveComponent("brand-terms")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: $props.showModal,
    class: "p-col-12 p-md-6 p-xl-4 gi-dialog modal-size",
    modal: true,
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:showModal', false)))
  }, {
    header: _withCtx(() => [
      _createElementVNode("span", {
        class: "close-btn-terms",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeTerms')))
      }),
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Button, {
          label: "OK",
          class: "back-terms p-pt-6",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('closeTerms')))
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_brand_terms)
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}